import { Module, Directive } from 'app/decorators';


@Module({
    name: 'app.directives.appLoading'
})
@Directive('app-loading', function($animate) {
    "ngInject";
    return {
        restrict: "A",
        link: function (scope, element, attributes) {
            $animate.leave( element.children().eq( 1 ) ).then(
                function cleanupAfterAnimation() {
                    // Remove the root directive element.
                    element.remove();

                    // Clear the closed-over variable references.
                    scope = element = attributes = null;

                }
            );
        }
    }
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/loading.app.js